import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

const CustomBackdrop = ({ text = "" }) => {
  return (
    <div>
      <Backdrop
        
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 2 }}
        open={true}
      >
        <CircularProgress color="inherit" size={100} disableShrink />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            sx={{ color: "white" }}
          >
            {text}
          </Typography>
        </Box>
      </Backdrop>
    </div>
  );
};

export default CustomBackdrop;
